/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React, { useState } from "react"
// import {useInView} from 'react-intersection-observer';
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import HppHeader from "../hp/header-hpp"
import Footer from "../shared/footer"
import HppIsiContainer from "../hp/hpp-isi-container";

import sal from "sal.js";
import ScreenshotMode from "../../utilities/screenshot-mode";

import "../../global.scss"
import NoRepModal, { getNoVacancyParamValue } from "../shared/no-rep-modal";

const HPPLayout = ({ children, location, references, jobCode, jobCodeDate, locationHostName }) => {
    const [entryModalShown, showEntryModal] = useState(false);
    const [showIsiTray, setShowIsiTray] = useState(true);
    const [noRep, setNoRep] = useState(false);
    let data_domain_script;

    React.useEffect(
        () => {
            setNoRep(getNoVacancyParamValue(location));
            if (noRep) {
                showEntryModal(false);
                sessionStorage.setItem('showEntryModal', false)
            }
        }
        , [location, noRep]
    )

    React.useEffect(
        () => {
            // Check if animations have been disabled for screenshot mode
            if (ScreenshotMode.disableAnimation) {
                // Animations have been disabled - add a class to our <body>
                // element to undo the CSS definitions put in place by the
                // various "data-sal" HTML attributes
                document.body.classList.add("disable-sal");
            } else {
                // Animations haven't been disabled - start scroll animations
                // normally
                sal({
                    threshold: 0.2
                });
            }

            // Check if the "showEntryModal" session storage item has been
            // defined
            if (sessionStorage.getItem('showEntryModal') === null) {
                // The "showEntryModal" session storage item doesn't yet exist -
                // Check if the modal has been disabled
                if (!ScreenshotMode.disableEntryModal) {
                    // The modal hasn't been disabled - set the "entryModalShown"
                    // state value, which if set to true will trigger the modal
                    // component being included in the header component
                    showEntryModal(true);
                }
            }

            sessionStorage.setItem('hostName', location.hostname);

            // Check if the ISI tray has been disabled for screenshot mode
            if (ScreenshotMode.disableIsiTray) {
                if (showIsiTray)
                    setShowIsiTray(false);
            } else {
                if (!showIsiTray)
                    setShowIsiTray(true);
            }

            // Check if the cookie consent banner has been disabled for screenshot mode
            if (ScreenshotMode.disableCookieBanner)
                document.body.classList.add("disable-cookie-banner");

            // Check for the presence of an anchor link hash - if an item matching that
            // ID exists on the page, scroll to it and leave room for the header so as
            // to not obscure the content
            if (window.location.hash) {
                // open ISI tray with this hash
                if (window.location.hash === '#isi') {
                    setTimeout(function () {
                        var psp = document.querySelector('#psp-panel');
                        psp.setAttribute('data-state', 'tallbutcollapse');
                        document.body.classList.add('no-overflow');
                    }, 300);
                }
                // navigate to DOM element that matches hash
                else {
                    let id = /^#(.+)$/.exec(window.location.hash);
                    if (id) {
                        // Hash found - check if there's an element matching that id
                        id = id[1];
                        const element = document.getElementById(id);

                        if (element) {
                            // An element exists - scroll to it
                            // Note: adding a delay here since it tends to bug out despite this
                            // being called on the React componentDidMount event
                            setTimeout(
                                () => {
                                    const bounds = element.getBoundingClientRect();
                                    let scrollPosition = window.pageYOffset + bounds.top;

                                    // Adjust for the height of the sticky header - this should be more
                                    // complicated: determining if the header is or will be sticky at
                                    // the point where we're scrolling to, measuring its size somehow...
                                    // but this is a last minute addition so I'm just throwing in some
                                    // hardcodes based on the current site design
                                    if (window.matchMedia("(min-width: 768px)").matches) {
                                        // Desktop
                                        scrollPosition -= 100;
                                    } else {
                                        // Mobile
                                        scrollPosition -= 100;
                                    }
                                    window.scrollTo(0, scrollPosition);
                                },
                                200
                            );
                        }
                    }
                }
            }
        },
        [
            entryModalShown,
            showIsiTray
        ]
    );

    const data = useStaticQuery(graphql`
     query HPPTitleQuery {
       site {
         siteMetadata {
           title
         }
       }
     }
   `);

    if (locationHostName === "auryxiahcp-staging.azurewebsites.net") {
        data_domain_script = "58455c1a-7215-4353-8182-17bb00627ea9-test";
    } else {
        data_domain_script = "58455c1a-7215-4353-8182-17bb00627ea9";
    }
    return (
        <>
            <a href="#main-content" id="skip-link">Skip to content</a>
            <div id="header-backdrop"></div>

            {noRep && <NoRepModal externalLink="https://www.auryxia.com/" />}

            <HppHeader
                location={location}
                siteTitle={data.site.siteMetadata ?.title || `Title`}
                entryModalShown={entryModalShown}
                onEntryModalDismissed={() => {
                    sessionStorage.setItem('showEntryModal', false)
                    showEntryModal(false)
                }}
                siteAudience='hpp' />

            <main
                id="main-content"
                aria-label={data.site.siteMetadata ?.title + " content"}>{children}</main>

            <HppIsiContainer
                showIsiTray={showIsiTray}
                references={references} />

            <Footer
                siteTitle={data.site.siteMetadata ?.title || `Title`}
                siteAudience='hpp'
                jobCode={jobCode}
                jobCodeDate={jobCodeDate}
                siteMapLink="/hyperphosphatemia/sitemap"
                url_hostname={data_domain_script} />
        </>
    )
}

HPPLayout.propTypes = {
    children: PropTypes.node.isRequired,
    references: PropTypes.array,
    jobCode: PropTypes.string,
    jobCodeDate: PropTypes.string,
    locationHostName: PropTypes.string

}

export default HPPLayout
